import omit from 'ramda/es/omit';
import { useCallback, useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { RangeType } from '../../constants';
import { RangeInputState } from '../../RangeInput/useRangeInput';

export default function useUpdatePriceFilters(values: RangeInputState) {
  const { updateRangeFilter } = useContext(AppliedFiltersContext);

  return useCallback(
    (rangeType: RangeType, value: number) => {
      const shouldClearFilter = value === 0;
      if (shouldClearFilter) {
        updateRangeFilter({
          filterKey: 'price',
          value: { ...omit([rangeType], values) }
        });
      } else {
        updateRangeFilter({
          filterKey: 'price',
          value: { ...values, [rangeType]: value }
        });
      }
    },
    [updateRangeFilter, values]
  );
}
